export default {"src":"/login-app/[GIT_HASH]/_next/static/media/arrow_drop_down.34c2132d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};